// vendors
import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { NotebookTypes } from '@mode/notebooks/contract';
// libs

// feature
import { BaseNotebookCellButtonComponent } from '../base-button.component';

@Component({
  selector: 'mode-notebook-run-cell-button',
  templateUrl: './notebook-run-cell-button.component.html',
  styleUrls: ['./notebook-run-cell-button.component.scss'],
})
export class NotebookRunCellButtonComponent extends BaseNotebookCellButtonComponent {
  @Input()
  canRun = false;

  @Input()
  nextCellToken?: string;

  @Input()
  contentType?: NotebookTypes.ContentType;

  @Output()
  runCell: EventEmitter<{ cellToken: string; nextCellToken?: string; contentType?: NotebookTypes.ContentType }> =
    new EventEmitter();

  @HostBinding('class.disabled')
  get disabled() {
    return !this.canRun;
  }

  constructor() {
    super();
  }

  run() {
    this.runCell.emit({ cellToken: this.cellToken, nextCellToken: this.nextCellToken, contentType: this.contentType });
  }
}
